import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { createConsentRuntime } from './consent-runtime.js';

const language = document.documentElement.lang.toLowerCase().split('-')[0];
const supportedLanguages = ['cs', 'sk', 'pl', 'de'];
const runtime = createConsentRuntime({
    cookieConsent: CookieConsent,
    document,
    window: globalThis,
});

globalThis.gigaPraceConsent = {
    queueMarketingEvent: event => runtime.queueMarketingEvent(event),
};

CookieConsent.run({
    onConsent: () => runtime.update(),
    onChange: () => {
        if (runtime.update()) {
            globalThis.location.reload();
        }
    },
    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom right',
            equalWeightButtons: false,
            flipButtons: true,
        },
        preferencesModal: {
            layout: 'center',
            position: 'center',
            equalWeightButtons: false,
            flipButtons: false,
        },
    },
    categories: {
        necessary: {readOnly: true},
        analytics: {},
        marketing: {},
        support: {},
    },
    language: {
        default: supportedLanguages.includes(language) ? language : 'cs',
        translations: {
            cs: {
                consentModal: {
                    title: 'Nastavení cookies',
                    description: 'Nezbytné cookies zajišťují základní funkce webu. Analytické, reklamní a podpůrné technologie použijeme jen podle vašeho výběru.',
                    acceptAllBtn: 'Povolit všechny',
                    acceptNecessaryBtn: 'Odmítnout volitelné',
                    showPreferencesBtn: 'Upravit nastavení',
                },
                preferencesModal: {
                    title: 'Nastavení cookies',
                    acceptAllBtn: 'Povolit všechny',
                    acceptNecessaryBtn: 'Povolit pouze nezbytné',
                    savePreferencesBtn: 'Uložit nastavení',
                    closeIconLabel: 'Zavřít nastavení cookies',
                    serviceCounterLabel: 'Služba|Služby',
                    sections: [
                        {title: 'Použití cookies', description: 'Volitelné kategorie můžete kdykoliv změnit v odkazu Nastavení cookies.'},
                        {title: 'Nezbytné <span class="pm__badge">Vždy zapnuto</span>', description: 'Nutné pro základní funkce webu.', linkedCategory: 'necessary'},
                        {title: 'Analytika', description: 'Měření návštěvnosti a používání webu.', linkedCategory: 'analytics'},
                        {title: 'Reklama', description: 'Měření a přizpůsobení reklam.', linkedCategory: 'marketing'},
                        {title: 'Podpora', description: 'Volitelný chat se zákaznickou podporou.', linkedCategory: 'support'},
                    ],
                },
            },
            sk: {
                consentModal: {
                    title: 'Nastavenie cookies',
                    description: 'Nevyhnutné cookies zabezpečujú základné funkcie webu. Analytické, reklamné a podporné technológie použijeme podľa vášho výberu.',
                    acceptAllBtn: 'Povoliť všetky',
                    acceptNecessaryBtn: 'Odmietnuť voliteľné',
                    showPreferencesBtn: 'Upraviť nastavenia',
                },
                preferencesModal: {
                    title: 'Nastavenie cookies',
                    acceptAllBtn: 'Povoliť všetky',
                    acceptNecessaryBtn: 'Povoliť iba nevyhnutné',
                    savePreferencesBtn: 'Uložiť nastavenia',
                    closeIconLabel: 'Zavrieť nastavenia cookies',
                    serviceCounterLabel: 'Služba|Služby',
                    sections: [
                        {title: 'Používanie cookies', description: 'Voliteľné kategórie môžete kedykoľvek zmeniť cez odkaz Nastavenia cookies.'},
                        {title: 'Nevyhnutné <span class="pm__badge">Vždy zapnuté</span>', description: 'Potrebné pre základné funkcie webu.', linkedCategory: 'necessary'},
                        {title: 'Analytika', description: 'Meranie návštevnosti a používania webu.', linkedCategory: 'analytics'},
                        {title: 'Reklama', description: 'Meranie a prispôsobenie reklamy.', linkedCategory: 'marketing'},
                        {title: 'Podpora', description: 'Voliteľný chat so zákazníckou podporou.', linkedCategory: 'support'},
                    ],
                },
            },
            pl: {
                consentModal: {
                    title: 'Ustawienia plików cookie',
                    description: 'Niezbędne pliki cookie zapewniają podstawowe funkcje serwisu. Technologie analityczne, reklamowe i wsparcia uruchomimy zgodnie z Twoim wyborem.',
                    acceptAllBtn: 'Zezwól na wszystkie',
                    acceptNecessaryBtn: 'Odrzuć opcjonalne',
                    showPreferencesBtn: 'Zmień ustawienia',
                },
                preferencesModal: {
                    title: 'Ustawienia plików cookie',
                    acceptAllBtn: 'Zezwól na wszystkie',
                    acceptNecessaryBtn: 'Zezwól tylko na niezbędne',
                    savePreferencesBtn: 'Zapisz ustawienia',
                    closeIconLabel: 'Zamknij ustawienia plików cookie',
                    serviceCounterLabel: 'Usługa|Usługi',
                    sections: [
                        {title: 'Korzystanie z plików cookie', description: 'Kategorie opcjonalne możesz zmienić w dowolnym momencie za pomocą linku Ustawienia cookies.'},
                        {title: 'Niezbędne <span class="pm__badge">Zawsze włączone</span>', description: 'Wymagane do podstawowego działania serwisu.', linkedCategory: 'necessary'},
                        {title: 'Analityka', description: 'Pomiar odwiedzin i korzystania z serwisu.', linkedCategory: 'analytics'},
                        {title: 'Reklama', description: 'Pomiar i personalizacja reklam.', linkedCategory: 'marketing'},
                        {title: 'Wsparcie', description: 'Opcjonalny czat z obsługą klienta.', linkedCategory: 'support'},
                    ],
                },
            },
            de: {
                consentModal: {
                    title: 'Cookie-Einstellungen',
                    description: 'Notwendige Cookies sichern grundlegende Funktionen. Analyse-, Werbe- und Support-Technologien verwenden wir nach Ihrer Auswahl.',
                    acceptAllBtn: 'Alle erlauben',
                    acceptNecessaryBtn: 'Optionale ablehnen',
                    showPreferencesBtn: 'Einstellungen ändern',
                },
                preferencesModal: {
                    title: 'Cookie-Einstellungen',
                    acceptAllBtn: 'Alle erlauben',
                    acceptNecessaryBtn: 'Nur notwendige erlauben',
                    savePreferencesBtn: 'Einstellungen speichern',
                    closeIconLabel: 'Cookie-Einstellungen schließen',
                    serviceCounterLabel: 'Dienst|Dienste',
                    sections: [
                        {title: 'Verwendung von Cookies', description: 'Optionale Kategorien können Sie jederzeit über den Link Cookie-Einstellungen ändern.'},
                        {title: 'Notwendig <span class="pm__badge">Immer aktiv</span>', description: 'Für grundlegende Funktionen der Website erforderlich.', linkedCategory: 'necessary'},
                        {title: 'Analyse', description: 'Messung der Besuche und Nutzung der Website.', linkedCategory: 'analytics'},
                        {title: 'Werbung', description: 'Messung und Anpassung von Werbung.', linkedCategory: 'marketing'},
                        {title: 'Support', description: 'Optionaler Chat mit dem Kundenservice.', linkedCategory: 'support'},
                    ],
                },
            },
        },
    },
});
